export const languagesData = {
  en: { name: "English" },
  sq: { name: "Albanian" },
  am: { name: "Amharic" },
  ar: { name: "Arabic" },
  hy: { name: "Armenian" },
  bn: { name: "Bengali" },
  bs: { name: "Bosnian" },
  bg: { name: "Bulgarian" },
  my: { name: "Burmese" },
  ca: { name: "Catalan" },
  zh: { name: "Chinese" },
  hr: { name: "Croatian" },
  cs: { name: "Czech" },
  da: { name: "Danish" },
  nl: { name: "Dutch" },
  et: { name: "Estonian" },
  fi: { name: "Finnish" },
  fr: { name: "French" },
  ka: { name: "Georgian" },
  de: { name: "German" },
  el: { name: "Greek" },
  gu: { name: "Gujarati" },
  hi: { name: "Hindi" },
  hu: { name: "Hungarian" },
  is: { name: "Icelandic" },
  id: { name: "Indonesian" },
  it: { name: "Italian" },
  ja: { name: "Japanese" },
  kn: { name: "Kannada" },
  kk: { name: "Kazakh" },
  ko: { name: "Korean" },
  lv: { name: "Latvian" },
  lt: { name: "Lithuanian" },
  mk: { name: "Macedonian" },
  ms: { name: "Malay" },
  ml: { name: "Malayalam" },
  mr: { name: "Marathi" },
  mn: { name: "Mongolian" },
  no: { name: "Norwegian" },
  fa: { name: "Persian" },
  pl: { name: "Polish" },
  pt: { name: "Portuguese" },
  pa: { name: "Punjabi" },
  ro: { name: "Romanian" },
  ru: { name: "Russian" },
  sr: { name: "Serbian" },
  sk: { name: "Slovak" },
  sl: { name: "Slovenian" },
  so: { name: "Somali" },
  es: { name: "Spanish" },
  sw: { name: "Swahili" },
  sv: { name: "Swedish" },
  tl: { name: "Tagalog" },
  ta: { name: "Tamil" },
  te: { name: "Telugu" },
  th: { name: "Thai" },
  tr: { name: "Turkish" },
  uk: { name: "Ukrainian" },
  ur: { name: "Urdu" },
  vi: { name: "Vietnamese" },
} as const;

export type LanguageIsoCode = keyof typeof languagesData;

const languageCountryCodes: Record<LanguageIsoCode, string> = {
  am: "ET",
  ar: "SA",
  bg: "BG",
  bn: "BD",
  bs: "BA",
  ca: "ES",
  cs: "CZ",
  da: "DK",
  de: "DE",
  el: "GR",
  en: "US",
  es: "ES",
  et: "EE",
  fa: "IR",
  fi: "FI",
  fr: "FR",
  gu: "IN",
  hi: "IN",
  hr: "HR",
  hu: "HU",
  hy: "AM",
  id: "ID",
  is: "IS",
  it: "IT",
  ja: "JP",
  ka: "GE",
  kk: "KZ",
  kn: "IN",
  ko: "KR",
  lt: "LT",
  lv: "LV",
  mk: "MK",
  ml: "IN",
  mn: "MN",
  mr: "IN",
  ms: "MY",
  my: "MM",
  nl: "NL",
  no: "NO",
  pa: "IN",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU",
  sk: "SK",
  sl: "SI",
  so: "SO",
  sq: "AL",
  sr: "RS",
  sv: "SE",
  sw: "KE",
  ta: "IN",
  te: "IN",
  th: "TH",
  tl: "PH",
  tr: "TR",
  uk: "UA",
  ur: "PK",
  vi: "VN",
  zh: "CN",
};

export function getCountryCodeForLanguage(code: LanguageIsoCode | string) {
  return (
    languageCountryCodes[code as LanguageIsoCode] ??
    code.slice(0, 2).toUpperCase()
  );
}

export const ChatGPTSupportedLanguagesData = Object.entries(languagesData).map(
  ([code, { name }]) => ({ code: code as LanguageIsoCode, name })
);
